export default (theme) => {
  const { darkGrey } = theme.palette.common

  return {
    bodyContainer: {
      backgroundColor: theme.palette.common.white,
      padding: '2rem',
      borderRadius: '0 0 1rem 1rem',
      [theme.breakpoints.down('sm')]: {
        padding: '1rem',
      },
    },

    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '1rem 0',
    },

    postSubmission: {
      textAlign: 'center',
    },

    postSubmitButton: {
      marginTop: '2rem',
    },

    checkbox: {
      color: darkGrey,
    },

    selectItem: {
      whiteSpace: 'normal',
    },

    multiselectValueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 3,
    },

    chip: {
      marginRight: theme.spacing(0.5),
      maxWidth: '100%',
      height: 'auto',
    },

    chipLabel: {
      whiteSpace: 'normal',
    },

    chipDeleteIcon: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }
}
